// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
::ng-deep .my-table {
  width: 100%;
}
::ng-deep .my-table thead tr {
  background: #fff;
}
::ng-deep .my-table .mdc-data-table__content .mat-mdc-row {
  border: 1px solid #e7e7e7;
}
::ng-deep .my-table .mdc-data-table__content .mat-mdc-row:nth-child(odd) {
  background-color: #f6f6f6;
}

.letter {
  display: inline-block;
}
.letter::before {
  content: " ";
}
.letter::after {
  content: ",";
}
.letter:last-child::after {
  content: "";
}

:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.toolbar {
  background-color: #41444d;
  height: 55px;
  color: white;
  font-size: 25px;
}

.button-bar {
  background-color: white;
  height: 55px;
  font-size: 25px;
  font-weight: 100;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  gap: 10px;
}
.button-bar button {
  min-width: 200px;
}
.button-bar button:nth-child(3) {
  margin-left: auto;
}

.main {
  flex: 1;
  padding: 0 20px 20px;
  display: flex;
  overflow: hidden;
}
.main-table {
  width: 100%;
  overflow: auto;
}

mat-form-field {
  margin: 20px 20px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/users/users-list/users-list.component.scss","webpack://./src/app/shared/table.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;EACE,WAAA;ADCJ;ACEM;EACE,gBAAA;ADAR;ACKM;EACE,yBAAA;ADHR;ACKQ;EACE,yBAAA;ADHV;;ACUA;EACE,qBAAA;ADPF;ACSE;EACE,YAAA;ADPJ;ACUE;EACE,YAAA;ADRJ;ACYI;EACE,WAAA;ADVN;;AAvBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA0BF;;AAvBA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AA0BF;;AAvBA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,SAAA;AA0BF;AAxBE;EACE,gBAAA;AA0BJ;AAzBI;EACE,iBAAA;AA2BN;;AAtBA;EAAO,OAAA;EACL,oBAAA;EACA,aAAA;EACA,gBAAA;AA0BF;AAzBE;EACE,WAAA;EACA,cAAA;AA2BJ;;AAvBA;EACE,mBAAA;AA0BF","sourcesContent":["@import '../../../shared/table';\r\n\r\n:host {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.toolbar {\r\n  background-color: #41444d;\r\n  height: 55px;\r\n  color: white;\r\n  font-size: 25px;\r\n}\r\n\r\n.button-bar {\r\n  background-color: white;\r\n  height: 55px;\r\n  font-size: 25px;\r\n  font-weight: 100;\r\n  border-bottom: 1px solid #e7e7e7;\r\n  display: flex;\r\n  gap: 10px;\r\n\r\n  button {\r\n    min-width: 200px;\r\n    &:nth-child(3) {\r\n      margin-left: auto;\r\n    }\r\n  }\r\n}\r\n\r\n.main {flex: 1;\r\n  padding: 0 20px 20px;\r\n  display: flex;\r\n  overflow: hidden;\r\n  &-table {\r\n    width: 100%;\r\n    overflow: auto;\r\n  }\r\n}\r\n\r\nmat-form-field {\r\n  margin: 20px 20px 0;\r\n}\r\n\r\n\r\n","::ng-deep {\r\n  .my-table {\r\n    width: 100%;\r\n\r\n    thead {\r\n      tr {\r\n        background: #fff;\r\n      }\r\n    }\r\n\r\n    .mdc-data-table__content {\r\n      .mat-mdc-row {\r\n        border: 1px solid #e7e7e7;\r\n\r\n        &:nth-child(odd) {\r\n          background-color: #f6f6f6;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.letter {\r\n  display: inline-block;\r\n\r\n  &::before {\r\n    content: '\\00a0'\r\n  }\r\n\r\n  &::after {\r\n    content: ','\r\n  }\r\n\r\n  &:last-child {\r\n    &::after {\r\n      content: ''\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
